<script lang="ts">
	import { onDestroy, onMount } from "svelte";
	import { slide } from "svelte/transition";

	export let showNav = true;
	export let paddingTarget = "scroll-collapse-spacing";
	export let paddingHeightTarget: string = "";

	let scrollCollapseSpacingRef: HTMLElement | null = null;
	let ref: HTMLElement;
	let lastScrollPosition = 0;
	const scrollThreshold = 0;
	let initHeight = 0;
	let animationFrameId: number | null = null;
	let scrollContainer: HTMLElement | Window;

	onMount(() => {
		// Batch all DOM reads first
		scrollCollapseSpacingRef = document.getElementById(paddingTarget);
		scrollContainer = document.querySelector(".virtual-list-wrapper") as HTMLElement || window;

		// Get initial height (read phase)
		if (paddingHeightTarget) {
			initHeight =
				document.getElementById(paddingHeightTarget)?.getBoundingClientRect()
					.height || 0;
		} else if (ref) {
			initHeight = ref.getBoundingClientRect().height;
		}

		// Batch all DOM writes
		if (scrollCollapseSpacingRef) {
			scrollCollapseSpacingRef.style.paddingTop = `${initHeight}px`;
		}

		// Use passive event listener for better scroll performance
		scrollContainer?.addEventListener("scroll", handleScroll, {
			passive: true
		});

		return () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
		};
	});

	onDestroy(() => {
		scrollContainer?.removeEventListener("scroll", handleScroll);
	});

	function handleScroll() {
		if (animationFrameId) {
			cancelAnimationFrame(animationFrameId);
		}
		const currentScrollPosition = getScrollPosition();

		animationFrameId = requestAnimationFrame(() => {
			// Determine if we should show nav (all logic in one place)
			const shouldShow =
				currentScrollPosition < initHeight ||
				currentScrollPosition < 100 ||
				lastScrollPosition - currentScrollPosition > scrollThreshold;

			// Only update if changed
			if (shouldShow !== showNav) {
				showNav = shouldShow;
			}

			lastScrollPosition = currentScrollPosition;
		});
	}

	function getScrollPosition(): number {
		if (scrollContainer === window) {
			return window.scrollY || document.documentElement.scrollTop;
		}
		return (scrollContainer as HTMLElement).scrollTop;
	}
</script>

<svelte:window />

{#if showNav}
	<div
		transition:slide={{
			duration: 300,
			axis: "y"
		}}
		bind:this={ref}
		class={`${$$props.class} w-full`}
	>
		<slot />
	</div>
{/if}
